module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPerPage) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_c('label', [_vm._v("Per page")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select transaction type"
    },
    on: {
      "change": function($event) {
        _vm.dropPagination();
        _vm.loadResources()
      }
    },
    model: {
      value: (_vm.perPage),
      callback: function($$v) {
        _vm.perPage = $$v
      },
      expression: "perPage"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "10",
      "label": "10"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "15",
      "label": "15"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "20",
      "label": "20"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "25",
      "label": "25"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "50",
      "label": "50"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "100",
      "label": "100"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-striped",
    attrs: {
      "id": _vm.resourceName + '-table'
    }
  }, [_c('thead', [_c('tr', [_vm._l((_vm.fields), function(field) {
    return _c('th', {
      class: [_vm.sorting == _vm.getSortFieldName(field) ? _vm.sortingType : ''],
      on: {
        "click": function($event) {
          return _vm.sort(field)
        }
      }
    }, [_c('span', {
      class: [field.sort ? 'sortable' : '']
    }, [_vm._v("\n            " + _vm._s(field.label) + "\n          ")])])
  }), _vm._v(" "), (!_vm.actionsList) ? _c('th', [_vm._v("Actions")]) : _vm._e()], 2)]), _vm._v(" "), (_vm.resources.length) ? _c('tbody', _vm._l((_vm.resources), function(resource) {
    return _c('tr', [_vm._l((_vm.fields), function(field) {
      return _c('td', [(field['img'] !== undefined && field['img']) ? _c('img', {
        attrs: {
          "src": _vm.recValue(resource, field.name)
        }
      }) : (field['img'] !== undefined && field['img']) ? _c('span', [_vm._v("\n            -\n          ")]) : (field['money'] !== undefined && field['money']) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.toMoney(_vm.recValue(resource, field.name), resource['currency'])) + "\n          ")]) : (field['datetime'] !== undefined && field['datetime']) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.formatDateTime(_vm.recValue(resource, field.name))) + "\n          ")]) : (field['url'] !== undefined && field['url']) ? _c('span', [_c('a', {
        attrs: {
          "href": _vm.recValue(resource, field.name),
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.recValue(resource, field.name)))])]) : (field['datetimeSec'] !== undefined && field['datetimeSec']) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.formatDateTime(_vm.recValue(resource, field.name), true)) + "\n          ")]) : (field['date'] !== undefined && field['date']) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.formatDate(_vm.recValue(resource, field.name))) + "\n          ")]) : (field['decorators'] !== undefined) ? _c('span', [_c('span', {
        class: field['decorators']['classes'][_vm.recValue(resource, field.name)]
      }, [_vm._v(_vm._s(field['decorators']['values'][_vm.recValue(resource, field.name)]))])]) : (field['blockLabel'] !== undefined) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.recValue(resource, field.name)) + "\n            "), (!resource.active) ? _c('span', {
        staticClass: "red-tag"
      }, [_vm._v("(blocked)")]) : _vm._e()]) : _c('span', [_vm._v("\n            " + _vm._s(_vm.recValue(resource, field.name)) + "\n          ")])])
    }), _vm._v(" "), (!_vm.actionsList) ? _c('td', [(!_vm.contactsList) ? _c('span', _vm._l((_vm.actionRoutes), function(route) {
      return _c('span', [_vm._v("\n                 \n              "), (route.returnId === undefined || !route.returnId) ? _c('router-link', {
        attrs: {
          "to": {
            name: route.name,
            params: _vm.generateObj(route.idName, resource.id)
          }
        }
      }, [_vm._v(_vm._s(route.label))]) : _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.returnId(route.name, resource.id)
          }
        }
      }, [_vm._v("\n                  " + _vm._s(route.label) + "\n                ")])], 1)
    }), 0) : _c('span', _vm._l((_vm.actionRoutes), function(route) {
      return _c('span', [_vm._v("\n                 "), _c('router-link', {
        attrs: {
          "to": {
            name: route.name,
            params: {
              contact_id: resource.id
            }
          }
        }
      }, [_vm._v(_vm._s(route.label))])], 1)
    }), 0)]) : _vm._e()], 2)
  }), 0) : _c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.fields.length + 1
    }
  }, [_vm._v("\n          No data\n        ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pagination.pages > 1),
      expression: "pagination.pages > 1"
    }],
    staticClass: "pagination"
  }, _vm._l((_vm.pagination.pages), function(page) {
    return _c('span', {
      class: {
        active: page == _vm.pagination.currentPage
      },
      on: {
        "click": function($event) {
          return _vm.paginate(page)
        }
      }
    }, [_vm._v("\n        " + _vm._s(page) + "\n    ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c68c89e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResourceList.vue
// module id = 709
// module chunks = 0